"use client";
import React from "react";
import Footer from "../components/Footer";
import PlainText from "../components/common/PlainText";

const TermsOfUse: React.FC = () => {

    const sections = [
        {
            id: 1,
            title: "Acceptance",
            titleHighlight: "of Terms",
            showId: true,
            content: [
                'WELCOME TO EPAYR ("WEBSITE"), OWNED AND OPERATED BY [YOUR COMPANY NAME OR INDIVIDUAL NAME] ("WE," "US," OR "OUR"). THESE TERMS OF USE ("TERMS") GOVERN YOUR ACCESS TO AND USE OF THE WEBSITE, INCLUDING ANY CONTENT, FUNCTIONALITY, AND SERVICES OFFERED ON OR THROUGH THE WEBSITE (COLLECTIVELY, THE "SERVICES").',
                'BY ACCESSING OR USING THE WEBSITE, YOU ("YOU" OR "USER") AGREE TO BE BOUND BY THESE TERMS. IF YOU DO NOT AGREE TO THESE TERMS, YOU MUST NOT ACCESS OR USE THE WEBSITE.',
            ],
        },
        {
            id: 2,
            title: "Description",
            titleHighlight: "of Services",
            showId: true,
            content: [
                '2.1. "EPAYR IS A PLATFORM CONNECTING BUSINESSES WITH FREELANCE PROFESSIONALS".',
                '2.2. "EPAYR PROVIDES ONLINE EDUCATIONAL COURSES IN [SPECIFIC SUBJECT]".',
                '2.3. "EPAYR IS A COMMUNITY FORUM FOR [SPECIFIC INTEREST]".',
            ],
        },
        {
            id: 3,
            title: "User",
            titleHighlight: "Accounts",
            showId: true,
            titleReverse: true,
            content: [
                '3.1. Account Creation: To access certain features of the Website, you may be required to create an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.',
                '3.2. Account Security: You are responsible for maintaining the confidentiality of your account credentials (username and password) and for all activities that occur under your account. You agree to notify us immediately of any unauthorized access to or use of your account. We will not be liable for any loss or damage arising from your failure to protect your account credentials.',
                '3.3. Account Termination: We reserve the right to suspend or terminate your account at any time, with or without cause, and without prior notice.',
            ],
        },
        {
            id: 4,
            title: "User",
            titleHighlight: "Content",
            showId: true,
            titleReverse: true,
            content: [
                '4.1. Definition: "User Content" means any content that you submit, upload, publish, display, or otherwise make available through the Website, including but not limited to text, images, videos, audio, and other materials.',
                '4.2. Your Responsibility: You are solely responsible for your User Content and the consequences of posting or publishing it. You represent and warrant that your User Content does not violate these Terms, any applicable law, or the rights of any third party.',
                '4.3. Our Rights: By posting User Content, you grant us a non-exclusive, worldwide, royalty-free, perpetual, irrevocable, and sublicensable license to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, perform, and display your User Content in connection with the Website and our business.',
                '4.4. Content Removal: We have the right, but not the obligation, to review, edit, or remove any User Content that violates these Terms or is otherwise objectionable.'
            ],
        },
        {
            id: 5,
            title: "Disclaimer of",
            titleHighlight: "Warranties",
            showId: true,
            content: [
                'THE WEBSITE AND SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE WEBSITE WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.',
            ],
        },
        {
            id: 6,
            title: "Limitation",
            titleHighlight: "of Liability",
            showId: true,
            content: [
                "TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, WE WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE WEBSITE OR SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. OUR TOTAL LIABILITY TO YOU FOR ANY CLAIM ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR THE WEBSITE WILL NOT EXCEED [DOLLAR AMOUNT OR A REASONABLE LIMIT, E.G., $100].",
            ],
        },
        {
            id: 7,
            title: "INDEMNIFICATION",
            showId: true,
            content: [
                "YOU AGREE TO INDEMNIFY, DEFEND, AND HOLD US HARMLESS FROM AND AGAINST ANY AND ALL CLAIMS, LIABILITIES, DAMAGES, LOSSES, COSTS, AND EXPENSES (INCLUDING ATTORNEYS' FEES) ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE WEBSITE, YOUR USER CONTENT, OR YOUR VIOLATION OF THESE TERMS.",
            ],
        },
        {
            id: 8,
            title: "Links to",
            titleHighlight: "Third-Party Websites",
            showId: true,
            content: [
                "THE WEBSITE MAY CONTAIN LINKS TO THIRD-PARTY WEBSITES. WE ARE NOT RESPONSIBLE FOR THE CONTENT OR PRIVACY PRACTICES OF THESE WEBSITES. YOU ACCESS THESE WEBSITES AT YOUR OWN RISK.",
            ],
        },
        {
            id: 9,
            title: "Modification",
            titleHighlight: "of Terms",
            showId: true,
            titleReverse: true,
            content: [
                "WE RESERVE THE RIGHT TO MODIFY THESE TERMS AT ANY TIME. WE WILL POST THE UPDATED TERMS ON THE WEBSITE AND INDICATE THE EFFECTIVE DATE. YOUR CONTINUED USE OF THE WEBSITE AFTER THE POSTING OF THE UPDATED TERMS CONSTITUTES YOUR ACCEPTANCE OF THE CHANGES.",
            ],
        },
        {
            id: 10,
            title: "Governing",
            titleHighlight: "Law",
            showId: true,
            content: [
                "THESE TERMS ARE GOVERNED BY AND CONSTRUED IN ACCORDANCE WITH THE LAWS OF [STATE/PROVINCE] AND [COUNTRY], WITHOUT REGARD TO ITS CONFLICT OF LAW PRINCIPLES.",
            ],
        },
    ];

  return (
        <main>
        <PlainText
      title="Terms of Use"
      titleHighlight="EPAYR Website"
      sections={sections}
      sectionContentSx={{
        color: "gray.400",
        lineHeight: "150% !important",
        textTransform: "uppercase",
      }}
    />
        <Footer 
              buttonText="" 
              buttonLink=""
              ctaText={{
                prefix: '',
                highlight1: '',
                middle: '',
                highlight2: '',
                suffix: ''
              }}
            />
        </main>
  );
};

export default TermsOfUse;
